module.exports = __webpack_public_path__ + "img/under.5665f7b3.svg";